


















import { Vue, Component, Prop } from 'vue-property-decorator';
import IFormField from '@/modules/form/interfaces/IFormField.d.ts';

@Component({
    name: 'FormTextarea',
})
export default class FormTextarea extends Vue {
    @Prop() public formField!: IFormField;
}
